import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12 7.46154L17.8778 2.78948C18.533 2.26863 19.5 2.73525 19.5 3.5723V15.0559C19.5 15.3608 19.3609 15.649 19.1222 15.8387L12.3111 21.2527C12.129 21.3975 11.871 21.3975 11.6889 21.2527L4.87776 15.8387C4.63909 15.649 4.5 15.3608 4.5 15.0559V3.5723C4.5 2.73525 5.46698 2.26863 6.12224 2.78947L12 7.46154ZM12 7.46154V21"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
